import Store from "../store/store";

export default {
    computed: {
        user() {
            return Store.state.user;
        }
    },
    methods: {
        async getUserServices(page, limit = 20,  {
            selection,
            excluded,
            search,
            cancelToken
        } = {}) {
            const params = {
                page: page,
                limit: limit,
                order: "latest",
            }

            if (selection) {
                params.only_ids = selection
            }
            if (excluded) {
                params.exclude_ids = excluded
            }
            if (search) {
                params.search = search
            }

            return this.$http.get(`${ab.apiUrl}/users/${this.user.id}/services`, {
                params,
                cancelToken
            });
        },

        async getUserService(id) {
            const result = await this.$http.get(`${ab.apiUrl}/users/${this.user.id}/services/${id}`);
            return result.data.item;
        }
    }

};
